import { statusOf } from "@jkast90/kast-common/api-client";
import { createQueryClient } from "@jkast90/kast-common/query-client";

// The status is the ApiError's (the client's `failure` hook sets it); a
// timeout or a network error has none. No subscribeToAuthErrors: the app has
// no 401 signal of its own. A query's 401 clears the cache, and so does the
// account changing (CacheScope).
export const queryClient = createQueryClient({ statusOf });
